/**
 * Get channel/reg-source id by current host.
 *
 * This logic is duplicated in multiple places in this project. Keep the
 * matching order consistent with the existing implementation.
 */
export function getChannel(host = (typeof window !== "undefined" ? window.location.host : "")) {
  const h = String(host || "");

  // 龙门 / 球界特殊落地页：不配渠道号
  if (h.indexOf("lmzb9.cn") > -1 || h.indexOf("qjtyg.com") > -1) {
    return "";
  }

  if (h === "web.uotxge.cn") {
    return "1ICB7S44";
  } else if (h.indexOf("dingzhiyou") > -1) {
    return "75V40X2C";
  } else if (h.indexOf("a657") > -1) {
    return "A9G7LANC";
  } else if (h.indexOf("jsbn016") > -1) {
    return "QJFGQ6VO";
  } else if (h.indexOf("lm8") > -1) {
    return "DYJ8UCDM";
  } else if (h.indexOf("qqafy") > -1) {
    return "DYJ8UCDM";
  } else if (h.indexOf("sdcvz") > -1) {
    return "DYJ8UCDM";
  } else if (h.indexOf("mjxyj") > -1) {
    return "DYJ8UCDM";
  } else if (h.indexOf("gogeiv") > -1) {
    return "DYJ8UCDM";
  } else if (h.indexOf("dkqsk") > -1) {
    return "DYJ8UCDM";
  } else if (h.indexOf("cwdgk") > -1) {
    return "DYJ8UCDM";
  } else if (h.indexOf("cwjhk") > -1) {
    return "DYJ8UCDM";
  } else if (h.indexOf("gdailr") > -1) {
    return "DYJ8UCDM";
  } else if (h.indexOf("duzhengqi") > -1) {
    return "DYJ8UCDM";
  } else if (h.indexOf("cqkdz") > -1) {
    return "DYJ8UCDM";
  } else if (h.indexOf("lm9") > -1) {
    return "G9C6141I";
  } else if (h.indexOf("lmliveapp") > -1) {
    return "5FWWLN9T";
  } else if (h.indexOf("lmliveob") > -1) {
    return "1BRH1THP";
  } else if (h.indexOf("livelmapp") > -1) {
    return "VZXAAX2T";
  } else if (h.indexOf("lmlivetop") > -1) {
    return "Y2ID2HQS";
  } else if (h.indexOf("tjmingya") > -1) {
    return "2A4KKOMD";
  } else if (h.indexOf("mingyakj") > -1) {
    return "T8EL5W76";
  } else if (h.indexOf("tjtianzhan") > -1) {
    return "MYSTBC8V";
  } else if (h.indexOf("tianzhankj") > -1) {
    return "JX37G5T9";
  } else if (h.indexOf("ios.dbabhkkj.com") > -1) {
    return "B656389S";
  } else if (h.indexOf("dkad33") > -1) {
    return "5Q2067ST";
  } else if (h.indexOf("bola6") > -1) {
    return "IGPSUUFU";
  } else if (h.indexOf("lm6") > -1) {
    return "ECZUFI1U";
  } else if (h.indexOf("lm7") > -1) {
    return "WBEVVFS1";
  } else if (h.indexOf("lmzb6") > -1) {
    return "7BLC38PY";
  } else if (h.indexOf("lmzb7") > -1) {
    return "R2SOIWHO";
  } else if (h.indexOf("lmzb9") > -1) {
    return "45JX1OMP";
  } else if (h.indexOf("lmlivebdu") > -1) {
    return "INXB28ML";
  } else if (h.indexOf("lmlivebdu01.com") > -1) {
    return "QPTAI23S";
  } else if (h.indexOf("www.lmlivebdu01.com") > -1) {
    return "QPTAI23S";
  } else if (h.indexOf("lmlivebdu02.com") > -1) {
    return "QPTAI23S";
  } else if (h.indexOf("www.lmlivebdu02.com") > -1) {
    return "QPTAI23S";
  } else if (h.indexOf("lmlivebdu03.com") > -1) {
    return "QPTAI23S";
  } else if (h.indexOf("www.lmlivebdu03.com") > -1) {
    return "QPTAI23S";
  } else if (h.indexOf("lmlivebdu04.com") > -1) {
    return "QPTAI23S";
  } else if (h.indexOf("www.lmlivebdu04.com") > -1) {
    return "QPTAI23S";
  } else if (h.indexOf("v1.cnzz.com") > -1) {
    return "SQ06JZ11";
  } else if (h.indexOf("lmlive88") > -1) {
    return "SQ06JZ11";
  } else if (h.indexOf("lmbd") > -1) {
    return "QPTAI23S";
  } else if (h.indexOf("lmbd01.com:51010") > -1) {
    return "QPTAI23S";
  } else if (h.indexOf("www.lmbd01.com:51010") > -1) {
    return "QPTAI23S";
  } else if (h.indexOf("lmbd02.com:51010") > -1) {
    return "QPTAI23S";
  } else if (h.indexOf("www.lmbd02.com:51010") > -1) {
    return "QPTAI23S";
  } else if (h.indexOf("lmbd03.com:51010") > -1) {
    return "QPTAI23S";
  } else if (h.indexOf("www.lmbd03.com:51010") > -1) {
    return "QPTAI23S";
  } else if (h.indexOf("lmbd04.com:51010") > -1) {
    return "QPTAI23S";
  } else if (h.indexOf("www.lmbd04.com:51010") > -1) {
    return "QPTAI23S";
  } else if (h.indexOf("lmbd01.com") > -1) {
    return "QPTAI23S";
  } else if (h.indexOf("www.lmbd01.com") > -1) {
    return "QPTAI23S";
  } else if (h.indexOf("lmbd02.com") > -1) {
    return "QPTAI23S";
  } else if (h.indexOf("www.lmbd02.com") > -1) {
    return "QPTAI23S";
  } else if (h.indexOf("lmbd03.com") > -1) {
    return "QPTAI23S";
  } else if (h.indexOf("www.lmbd03.com") > -1) {
    return "QPTAI23S";
  } else if (h.indexOf("lmbd04.com") > -1) {
    return "QPTAI23S";
  } else if (h.indexOf("www.lmbd04.com") > -1) {
    return "QPTAI23S";
  } else if (h.indexOf("lmjhadka.com") > -1) {
    return "QPTAI23S";
  } else if (h.indexOf("tawld.com") > -1) {
    return "8KB88TCH";
  } else if (h.indexOf("mkjaydx.com") > -1) {
    return "8KB88TCH";
  } else if (h.indexOf("axpdael.com") > -1) {
    return "8KB88TCH";
  } else if (h.indexOf("jxrheqv.com") > -1) {
    return "8KB88TCH";
  } else if (h.indexOf("fiskids.com") > -1) {
    return "8KB88TCH";
  } else if (h.indexOf("lpjnhgd.com") > -1) {
    return "8KB88TCH";
  } else if (h.indexOf("prglqi.com") > -1) {
    return "8KB88TCH";
  } else if (h.indexOf("wooydd.com") > -1) {
    return "8KB88TCH";
  } else if (h.indexOf("dbrpu.com") > -1) {
    return "8KB88TCH";
  } else if (h.indexOf("gpkvux.com") > -1) {
    return "8KB88TCH";
  } else if (h.indexOf("eqszy.com") > -1) {
    return "8KB88TCH";
  } else if (h.indexOf("xyuvjd.com") > -1) {
    return "8KB88TCH";
  } else if (h.indexOf("gxmqt") > -1) {
    return "8KB88TCH";
  } else if (h.indexOf("hjqks") > -1) {
    return "8KB88TCH";
  } else if (h.indexOf("tkfkw") > -1) {
    return "8KB88TCH";
  } else if (h.indexOf("dxhmc") > -1) {
    return "8KB88TCH";
  } else if (h.indexOf("nanonai") > -1) {
    return "8KB88TCH";
  } else if (h.indexOf("shanote") > -1) {
    return "8KB88TCH";
  } else if (h.indexOf("jinanrn.cn") > -1) {
    return "75V40X2C";
  } else if (h.indexOf("dingzhib.com") > -1) {
    return "75V40X2C";
  } else if (h.indexOf("lmldy123") > -1) {
    return "75V40X2C";
  } else if (h.indexOf("hzpdvf") > -1 || h.indexOf("szqcb") > -1) {
    return "OIUSQUUE";
  } else if (h.indexOf("dkyqzuc") > -1 || h.indexOf("gzkqh") > -1) {
    return "K3J0UBY6";
  } else if (h.indexOf("scmwyrb") > -1 || h.indexOf("hzlrg") > -1) {
    return "ATWLVPJ3";
  } else if (h.indexOf("vfwhzcn") > -1 || h.indexOf("cqmdz") > -1) {
    return "BXT0KSZW";
  } else if (h.indexOf("xzzpmbw") > -1 || h.indexOf("cdkdn") > -1) {
    return "WUON8Q9T";
  } else if (h.indexOf("rpqmyiy") > -1 || h.indexOf("hzldm") > -1) {
    return "QHSSTAM4";
  } else if (h.indexOf("mohegpt") > -1 || h.indexOf("sztqr") > -1) {
    return "AS8AHFQ7";
  } else if (h.indexOf("jio74") > -1 || h.indexOf("gzkqb") > -1) {
    return "P60XRTUX";
  } else if (h.indexOf("aajyvq") > -1 || h.indexOf("cdjnj") > -1) {
    return "4J621R02";
  } else if (h.indexOf("bkgswh") > -1 || h.indexOf("suifangjun") > -1 || h.indexOf("cqkbx") > -1 || h.indexOf("whhpp") > -1) {
    return "F9YSMV0I";
  } else if (h.indexOf("biylfu") > -1) {
    return "K3J0UBY6";
  } else if (h.indexOf("dptvhi") > -1) {
    return "ATWLVPJ3";
  } else if (h.indexOf("teydnq") > -1) {
    return "BXT0KSZW";
  } else if (h.indexOf("dfumub") > -1) {
    return "WUON8Q9T";
  } else if (h.indexOf("dfgpbo") > -1) {
    return "QHSSTAM4";
  } else if (h.indexOf("cvtbhf") > -1) {
    return "AS8AHFQ7";
  } else if (h.indexOf("lmzbseo.online") > -1 || h.indexOf("dengxiancheng") > -1) {
    return "AD67TGJL";
  } else if (h.indexOf("lmzbseo.store") > -1) {
    return "M00XOX1L";
  } else if (h.indexOf("lmzbseo.cc") > -1 || h.indexOf("naamou") > -1 || h.indexOf("szqlk.com") > -1) {
    return "AA4VRSIN";
  } else if (h.indexOf("lmzb0.vip") > -1 || h.indexOf("gzwkp") > -1) {
    return "X73YYLBK";
  } else if (h.indexOf("lmzb10.vip") > -1 || h.indexOf("pieagen") > -1) {
    return "FKMSK2PD";
  } else if (h.indexOf("lmzb11.vip") > -1 || h.indexOf("weifeichang") > -1 || h.indexOf("cqjbm.com") > -1) {
    return "F64K3PLE";
  } else if (
    h.indexOf("lmzbzj") > -1 ||
    h.indexOf("disibao") > -1 ||
    h.indexOf("qinxinmin") > -1 ||
    h.indexOf("niuxinyi") > -1 ||
    h.indexOf("xielihai") > -1 ||
    h.indexOf("whgxr") > -1 ||
    h.indexOf("cqlnk") > -1
  ) {
    return "EPQDH3T8";
  } else if (h.indexOf("wenpengfei") > -1) {
    return "WBBKYRK4";
  } else if (h.indexOf("yangpengkun") > -1) {
    return "MNF6QT75";
  } else if (h.indexOf("lizhenfu") > -1) {
    return "PMUW1N70";
  } else if (h.indexOf("leitaiyuan") > -1) {
    return "SBGC0G4X";
  } else if (h.indexOf("whhmp") > -1) {
    return "59ULR3QV";
  } else if (h.indexOf("gzhnm.com") > -1) {
    return "ON88LJ4Q";
  } else if (h.indexOf("hzkhp.com") > -1) {
    return "EDIUS3J5";
  } else if (h.indexOf("gzhrg.com") > -1) {
    return "BG2RO5ZT";
  } else {
    return "OFFICIAL";
  }
}

